module.exports = __webpack_public_path__ + "img/780-41f0f5.png";